import React from 'react';
import styled from 'styled-components';
import { IconButton } from '../../icons/IconContainer';
import { Flex } from '../../components/Flex';
import { NavigationTooltip } from '../../components/Tooltip';

const MenuTitle = styled(Flex).attrs({
    align: 'center',
    whiteSpace: 'nowrap'
})`
    visibility: ${({collapsed}) => collapsed ? "hidden" : "visible"};
    opacity: ${({collapsed}) => collapsed ? 0 : 1};
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: #FFFFFF;
    text-transform: capitalize;
    transition: visibility .5s, .5s linear;
`;

const NavigationItem = ({ item, collapsed, selected }) => {

    return(
        <>
            {collapsed
                ? <NavigationTooltip
                    text={item.tooltip || item.key}
                >
                    <IconButton background={!selected && "rgba(96, 146, 226, .3)"} hoverBackground={!selected && "#6092E2"}>
                        {item.icon}
                    </IconButton>
                </NavigationTooltip>
                : <IconButton background={!selected && "rgba(96, 146, 226, .3)"} hoverBackground={!selected && "#6092E2"} style={{ marginRight: "20px" }}>
                    {item.icon}
                </IconButton>}
            <MenuTitle collapsed={collapsed}>{item.title || item.key}</MenuTitle>
        </>
    )
};

export { NavigationItem };